import { TransformBigInt } from '../util';

export class TokenValue {
  @TransformBigInt()
  public eth: bigint | undefined;
  public usd: number | undefined;

  constructor(eth: bigint | undefined, usd: number | undefined) {
    this.eth = eth;
    this.usd = usd;
  }
}
